import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { publicApi } from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import WatchCard from "@/components/public/WatchCard";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";

export default function Watches() {
  const [watches, setWatches] = useState([]);
  const [brands, setBrands] = useState([]);
  const [searchParams] = useSearchParams();
  const [q, setQ] = useState(searchParams.get("q") || "");
  const [brand, setBrand] = useState("all");
  const [sort, setSort] = useState("newest");
  const [loading, setLoading] = useState(true);

  useEffect(() => { publicApi.get("/public/watches/brands").then((r) => setBrands(r.data)).catch(() => {}); }, []);

  const load = useCallback(async () => {
    setLoading(true);
    const params = { sort };
    if (q) params.q = q;
    if (brand !== "all") params.brand = brand;
    try { const r = await publicApi.get("/public/watches", { params }); setWatches(r.data); }
    finally { setLoading(false); }
  }, [q, brand, sort]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-5 py-14">
        <div className="text-center mb-10">
          <div className="text-[#c9a86a] tracking-[0.3em] text-xs mb-3">THE COLLECTION</div>
          <h1 className="text-3xl md:text-4xl font-semibold text-[var(--text)]">Watches for Sale</h1>
          <p className="text-[var(--text-2)] mt-3">Every piece authenticated. Private inventory available to VIP members.</p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mb-8">
          <div className="relative flex-1 max-w-sm">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--muted)]" />
            <Input placeholder="Search brand, model, reference…" value={q} onChange={(e) => setQ(e.target.value)}
              className="pl-9 bg-[var(--panel)] border-[var(--border-2)] text-[var(--text)]" data-testid="public-watch-search" />
          </div>
          <Select value={brand} onValueChange={setBrand}>
            <SelectTrigger className="sm:w-48 bg-[var(--panel)] border-[var(--border-2)] text-[var(--text)]" data-testid="public-brand-filter"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">All Brands</SelectItem>{brands.map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}</SelectContent>
          </Select>
          <Select value={sort} onValueChange={setSort}>
            <SelectTrigger className="sm:w-44 bg-[var(--panel)] border-[var(--border-2)] text-[var(--text)]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="newest">Newest</SelectItem>
              <SelectItem value="price_asc">Price: Low to High</SelectItem>
              <SelectItem value="price_desc">Price: High to Low</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {loading ? (
          <div className="text-center text-[var(--muted)] py-20">Loading…</div>
        ) : watches.length ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="watches-grid">
            {watches.map((w) => <WatchCard key={w.id} watch={w} />)}
          </div>
        ) : (
          <div className="text-center text-[var(--muted)] py-20">No watches match your search.</div>
        )}
      </section>
    </PublicLayout>
  );
}
